module.exports = __webpack_public_path__ + "static/media/orbit.e6c6bee5.svg";